import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/app/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Alert, Button, Col, DatePicker, Form, message, Popover, Row, Switch } from 'antd';
import { getAuthStore } from 'core/modules/auth/auth.store';
import { TaskState, TaskType } from 'core/modules/tasks/task.interface';
import { getTaskStore } from 'core/modules/tasks/task.store';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MoneyInput } from 'src/components/Form/MoneyInput';
import { UserSelect } from 'src/components/Form/UserSelect';
import styled from 'styled-components';
import { TaskDeadline } from '../Deadline';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Popover to confirm the change from one state to another */
export var TaskProgressConfirmPopopver = function TaskProgressConfirmPopopver(_ref) {
  var _populatedTask$conten, _populatedTask$conten2;

  var task = _ref.task,
      state = _ref.state,
      isDisabled = _ref.isDisabled,
      children = _ref.children,
      onConfirmed = _ref.onConfirmed;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getTaskStore = getTaskStore(),
      isLoading = _getTaskStore.isLoading,
      populateTask = _getTaskStore.populateTask;

  var _getAuthStore = getAuthStore(),
      canManageTasks = _getAuthStore.canManageTasks;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = useState({
    amount: '0'
  }),
      price = _useState[0],
      setPrice = _useState[1];

  var _useState2 = useState(false),
      isVisible = _useState2[0],
      setVisible = _useState2[1];

  var populatedTask = useMemo(function () {
    return populateTask(task);
  }, [task]);
  var deadline = populatedTask.content.type === TaskType.Report && (_populatedTask$conten = populatedTask.content.company) !== null && _populatedTask$conten !== void 0 && _populatedTask$conten.settings.deadlines ? (_populatedTask$conten2 = populatedTask.content.company) === null || _populatedTask$conten2 === void 0 ? void 0 : _populatedTask$conten2.settings.deadlines.find(function (it) {
    return it.state === state;
  }) : undefined;
  var requireAssignee = !task.assignedToUserId && state === TaskState.Close;
  populatedTask.type === TaskType.Report && !task.content.rate && state === TaskState.Close;
  var requiredPrice = populatedTask.type === TaskType.Report && state === TaskState.Close;
  var initialValues = useMemo(function () {
    if (!deadline) {
      return {};
    }

    return {
      change: true,
      date: moment(task.createdAt).add(deadline.amount, deadline.unit).endOf('day')
    };
  }, [task, deadline]);
  var trigger = state === task.state ? 'none' : 'click';

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var assignee, change, date, content;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              assignee = _ref2.assignee, change = _ref2.change, date = _ref2.date;
              content = undefined;

              if (!(task.type === TaskType.Report && requiredPrice)) {
                _context.next = 7;
                break;
              }

              if (!(!price || !price.amount)) {
                _context.next = 6;
                break;
              }

              message.error(t('tasks.changeState.error.requirePrice'));
              return _context.abrupt("return");

            case 6:
              content = _objectSpread(_objectSpread({}, task.content), {}, {
                price: price
              });

            case 7:
              if (!(requireAssignee && !assignee)) {
                _context.next = 10;
                break;
              }

              message.error(t('tasks.changeState.error.requireAssignee'));
              return _context.abrupt("return");

            case 10:
              onConfirmed(change ? date.toDate() : undefined, assignee, content);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    setVisible(false);

    if (task.type === TaskType.Report) {
      var _price;

      setPrice((_price = task.content.price) !== null && _price !== void 0 ? _price : {
        amount: '0'
      });
    }

    form.resetFields();
  }, [task]);

  if (isDisabled) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }

  return /*#__PURE__*/_jsx(Container, {
    getPopupContainer: function getPopupContainer(trigger) {
      return trigger.parentElement;
    },
    defaultOpen: isVisible,
    title: t('tasks.changeState.message', {
      state: t("tasks.state.".concat(state))
    }),
    content: /*#__PURE__*/_jsx(Content, {
      children: /*#__PURE__*/_jsxs(Form, {
        form: form,
        colon: false,
        layout: "vertical",
        initialValues: _objectSpread({}, initialValues),
        onFinish: onSubmit,
        children: [deadline && /*#__PURE__*/_jsxs("div", {
          className: "deadline-form",
          children: [/*#__PURE__*/_jsx(Alert, {
            message: t('tasks.changeState.deadlineAlert')
          }), /*#__PURE__*/_jsxs(Row, {
            justify: "space-between",
            children: [/*#__PURE__*/_jsx(Col, {
              span: 5,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "change",
                valuePropName: "checked",
                children: /*#__PURE__*/_jsx(Switch, {})
              })
            }), /*#__PURE__*/_jsx(Col, {
              span: 19,
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "date",
                children: /*#__PURE__*/_jsx(DatePicker, {
                  showTime: true,
                  placeholder: 'Selecciona el deadline...',
                  format: "DD/MM/YYYY HH:mm"
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Form.Item, {
            shouldUpdate: true,
            children: function children(form) {
              var deadline = form.getFieldValue('date');
              var date = deadline ? moment(deadline).toDate() : undefined;
              return /*#__PURE__*/_jsx(TaskDeadline, {
                deadline: date
              });
            }
          })]
        }), requireAssignee && /*#__PURE__*/_jsx(Form.Item, {
          name: "assignee",
          label: t('form.task.assignee.label'),
          rules: [{
            required: true,
            message: t('tasks.changeState.error.requireAssignee')
          }],
          children: /*#__PURE__*/_jsx(UserSelect, {
            isReadonly: !canManageTasks,
            placeholder: t('form.task.assignee.placeholder'),
            emptyMessage: t('form.task.assignee.empty')
          })
        }), requiredPrice && /*#__PURE__*/_jsx(Form.Item, {
          label: t('form.task.price.label'),
          rules: [{
            required: true
          }],
          children: /*#__PURE__*/_jsx(MoneyInput, {
            value: price,
            onChange: setPrice
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "footer",
          children: /*#__PURE__*/_jsx(Button, {
            type: "primary",
            block: true,
            htmlType: "submit",
            loading: isLoading,
            children: t('confirm')
          })
        })]
      })
    }),
    trigger: trigger,
    children: children
  });
}; // Styles

var Container = styled(Popover).withConfig({
  displayName: "ConfirmPopover__Container",
  componentId: "sc-1g1xggi-0"
})(["div.content{max-width:100px;}"]);
var Content = styled.div.withConfig({
  displayName: "ConfirmPopover__Content",
  componentId: "sc-1g1xggi-1"
})(["max-width:300px;margin:auto;.ant-alert{margin-bottom:12px;}.ant-picker{width:100%;}.footer{text-align:center;}.deadline-form{.ant-row-space-between{width:250px;}}"]);